import { serverApiConfig } from '../config';
import emitter from '../utilities/emitter.jsx';
import { getGrpcResponse } from '../utilities/getGrpcResponse';
const { AccountClient } = require('../grpc/generated/account_grpc_web_pb');

export default class AccountDataInfo {
  async accountInfo(request, metadata) {
    try {
      let accountClient = new AccountClient(
        serverApiConfig(localStorage.getItem('trade.server')),
        null,
        null
      );
      accountClient.account(request, metadata, (err, response) => {
        if (err) {
          console.log(err);
          return;
        }
        let accountInfoData = {
          login: getGrpcResponse(response)?.[0],
          currency_digits: getGrpcResponse(response)?.[1],
          balance: getGrpcResponse(response)?.[2],
          credit: getGrpcResponse(response)?.[3],
          equity: getGrpcResponse(response)?.[4],
          margin: getGrpcResponse(response)?.[5],
          margin_free: getGrpcResponse(response)?.[6],
          margin_level: getGrpcResponse(response)?.[7],
          margin_leverage: getGrpcResponse(response)?.[8],
          profit: getGrpcResponse(response)?.[9]
        };
        emitter.instance.emit('accountInfo', accountInfoData);
      });
    } catch (e) {
      console.log(e);
    }
  }
}
